<script setup lang="ts">
// these root level pages just render the actual view under [lcid]
import Releases from './[lcid]/releases.vue'
interface TProps {
  lcid: string
  homeData: any
}
const props = defineProps<TProps>()
</script>
<template>
  <Releases v-bind="props" />
</template>
